/**
 * settledPool — 동시성 제한 하에서 items 를 fn 으로 매핑하고, Promise.allSettled
 * 와 동일한 [{status:'fulfilled',value}|{status:'rejected',reason}] 결과를 원래
 * 순서로 반환한다. 한 번에 최대 limit 개의 fn 만 in-flight 로 유지한다.
 *
 * paper-trader 는 SSH 리버스 터널 1개 뒤에 있어, 수십 개 요청을 동시에 쏘면
 * 터널이 포화돼 간헐 503(타임아웃)이 난다. 요청 총량은 유지하되 순간 부하만
 * 낮춰 터널을 보호하는 용도 (DAS-158).
 *
 * @template T, R
 * @param {T[]} items 처리할 항목 목록
 * @param {number} limit 동시 실행 상한 (1 이상)
 * @param {(item: T, index: number) => Promise<R>} fn 항목별 비동기 작업
 * @returns {Promise<Array<{status:'fulfilled',value:R}|{status:'rejected',reason:*}>>}
 */
export async function settledPool(items, limit, fn) {
    const list = Array.isArray(items) ? items : [];
    const results = new Array(list.length);
    const cap = Math.max(1, Math.min(limit | 0, list.length));
    let next = 0;
    const worker = async () => {
        while (true) {
            const i = next;
            next += 1;
            if (i >= list.length) return;
            try {
                results[i] = { status: "fulfilled", value: await fn(list[i], i) };
            } catch (reason) {
                results[i] = { status: "rejected", reason };
            }
        }
    };
    const workers = [];
    for (let k = 0; k < cap; k++) workers.push(worker());
    await Promise.all(workers);
    return results;
}
